import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline';
import React from 'react';
import seo from '../../data';
const terms = {
	title: 'Terms & Conditions',
	introduction: `Welcome to ${seo.companyName}. These Terms & Conditions govern your use of our website and contact form. By accessing or using our website, you agree to comply with these Terms & Conditions.`,
	sections: [
		{
			title: 'Intellectual Property',
			content: `All content, including text, images, logos, and graphics, on our website is the property of ${seo.companyName} and protected by copyright laws. You may not use, reproduce, or distribute our content without prior written permission.`,
		},
		{
			title: 'Accuracy of Information',
			content:
				'We strive to provide accurate and up-to-date information on our website, but we make no warranties or representations about the completeness, accuracy, or reliability of the content.',
		},
		{
			title: 'Limitation of Liability',
			content: `${seo.companyName} shall not be liable for any direct, indirect, incidental, special, or consequential damages arising out of or in connection with your use of our website or contact form.`,
		},
		{
			title: 'Third-Party Links',
			content:
				'Our website may contain links to third-party websites or resources. We are not responsible for the content, accuracy, or availability of these external sites and do not endorse or recommend any products or services offered on them.',
		},
		{
			title: 'Governing Law',
			content:
				'These Terms & Conditions shall be governed by and construed in accordance with the laws of The United States of America, without regard to its conflict of law provisions.',
		},
		{
			title: 'Changes to Terms & Conditions',
			content:
				'We reserve the right to update or modify these Terms & Conditions at any time. Any changes will be effective immediately upon posting on this page.',
		},
	],
	contact: {
		title: 'Contact Us',
		content: `If you have any questions or concerns about these Terms & Conditions, please contact us at ${seo.company.email}.`,
	},
};

export default function Terms() {
	return (
		<div className='bg-white'>
			<div className='mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8 lg:py-40'>
				<div className='mx-auto max-w-4xl divide-y divide-gray-900/10'>
					<h2 className='text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl'>
						{terms.title}
					</h2>
					<p className='mt-4 text-xl text-gray-500'>{terms.introduction}</p>
					<dl className='mt-10 space-y-6 divide-y divide-gray-900/10 pb-10'>
						{terms.sections.map((section, index) => (
							<Disclosure
								key={index}
								as='div'
								className='pt-6'
							>
								<dt>
									<DisclosureButton className='group flex w-full items-start justify-between text-left text-gray-900'>
										<span className='text-base/7 font-semibold'>{section.title}</span>
										<span className='ml-6 flex h-7 items-center'>
											<PlusIcon
												aria-hidden='true'
												className='h-6 w-6 group-data-[open]:hidden'
											/>
											<MinusIcon
												aria-hidden='true'
												className='h-6 w-6 [.group:not([data-open])_&]:hidden'
											/>
										</span>
									</DisclosureButton>
								</dt>
								<DisclosurePanel
									as='dd'
									className='mt-2 pr-12'
								>
									<p className='text-base/7 text-gray-600'>{section.content}</p>
								</DisclosurePanel>
							</Disclosure>
						))}
					</dl>
					<div className='mt-12'>
						<h3 className='text-xl font-bold text-gray-900'>{terms.contact.title}</h3>
						<p className='text-gray-600'>{terms.contact.content}</p>
					</div>
				</div>
			</div>
		</div>
	);
}
